import { IGetObraEstruturaOrganizacionalFuncionarioDropDownUseCase } from "../../../presentation/useCases/read/get_obra_estrutura_organizacional_funcionario_drop_down_use_case";
import { ObraEstruturaOrganizacionalFuncionario } from "../../models/obra_estrutura_organizacional_funcionario";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraEstruturaOrganizacionalFuncionarioDropDownUseCase
 */

export class GetObraEstruturaOrganizacionalFuncionarioDropDownUseCase
  implements IGetObraEstruturaOrganizacionalFuncionarioDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraEstruturaOrganizacionalFuncionarioDropdown(
  ): Promise<ObraEstruturaOrganizacionalFuncionario[]> {
    return await this.repository.getObraEstruturaOrganizacionalFuncionarioDropdown();
  }
}
